import type { PrecomputedBiothreatSignal } from "./types"
import Papa from "papaparse"

export const exportPrecomputedSignalsToCsv = (
  signals: PrecomputedBiothreatSignal[]
) => {
  const rows = signals.map(signal => ({
    source: signal.source,
    title: signal.title,
    resolved_location: signal.resolved_location,
    disease: signal.clean_disease_codes.join("; "),
    cluster_count: signal.cluster_count,
    publish_time: signal.publish_time,
    impact_score: signal.impact_score ?? "",
    url: signal.url,
    nwss_status: signal.nwss_meta?.status ?? "",
    nwss_disease: signal.nwss_meta?.disease ?? "",
    nwss_last_detection: signal.nwss_meta?.last_detection_date ?? "",
    gdelt_geo_level: signal.gdelt_meta?.geo_level ?? "",
  }))
  return Papa.unparse(rows)
}
